.root {
  display: flex;
  flex-direction: column;
  gap: 24px;
  max-width: 640px;
  width: 100%;
}

.header {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding-bottom: 32px;
}


.fields {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.options {
  align-items: center;
  display: flex;
  justify-content: space-between;
  padding: 8px 0;
}

.recover {
  color: var(--color-foreground);
  font-size: 14px;
  font-weight: 500;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
}

.actions {
  display: flex;
  gap: 16px;
  padding: 8px 0;

  > button {
    flex: 1;
  }
}
